export type ScheduleSearchAddress = {
  address?: string | null;
  number?: string | number | null;
  neighborhood?: string | null;
  complement?: string | null;
  city?: string | null;
  uf?: string | null;
};

export function formatScheduleCardStatus(item: {
  has_card?: boolean;
  card_id?: number | null;
}): string {
  if (item.has_card) {
    return item.card_id != null ? `Card já criado (#${item.card_id})` : "Card já criado";
  }
  return "Ainda não tem card";
}

export function formatScheduleDateTime(raw?: string | null): string {
  if (!raw) return "Data não informada";

  const match = String(raw).match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/
  );
  if (!match) return String(raw);

  const [, year, month, day, hour, minute] = match;
  return `${day}/${month}/${year} às ${hour}:${minute}`;
}

export function formatPersonName(
  person?: { first_name?: string | null } | null,
  fallback = "Não informado"
): string {
  const name = person?.first_name?.trim();
  return name || fallback;
}

export function formatPropertyLabel(
  property?: { id?: number | null; title?: string | null } | null
): string {
  if (!property) return "Imóvel não informado";

  const title = property.title?.trim() || "Sem título";
  if (property.id == null) return title;
  return `#${property.id} • ${title}`;
}

export function formatPropertyAddress(address?: unknown): string {
  if (!address || typeof address !== "object") {
    return "Endereço não informado";
  }

  const value = address as ScheduleSearchAddress;
  const parts = [
    value.address,
    value.number,
    value.neighborhood,
    value.complement,
    value.city,
    value.uf,
  ].filter((part) => part != null && String(part).trim() !== "");

  return parts.length > 0 ? parts.map(String).join(", ") : "Endereço não informado";
}
